export const shiftAppBase = `${process.env.PUBLIC_URL || ''}/`;

export function isShiftStandalone(): boolean {
  return window.matchMedia?.('(display-mode: standalone)').matches === true
    || (navigator as Navigator & { standalone?: boolean }).standalone === true;
}

export function isAppleMobile(): boolean {
  return /iPhone|iPad|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export async function registerShiftWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!window.isSecureContext || !('serviceWorker' in navigator)) return null;
  return navigator.serviceWorker.register(`${shiftAppBase}shift-service-worker.js`, { scope: shiftAppBase });
}